import React, { useState, useEffect } from 'react';
import { DatabaseService } from '../db/database';
import syncService from '../services/syncService';
import Settings from './Settings';
import './Header.css';

function Header({ onSettingsUpdate }) {
  const [userInfo, setUserInfo] = useState({ name: '', email: '', countryCode: '' });
  const [syncing, setSyncing] = useState(false);
  const [syncMessage, setSyncMessage] = useState('');
  const [showSettings, setShowSettings] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    loadUserInfo();
  }, []);

  const loadUserInfo = async () => {
    const info = await DatabaseService.getUserInfo();
    setUserInfo(info);
  };

  const handleSync = async () => {
    setSyncing(true);
    setSyncMessage('Syncing...');

    try {
      const result = await syncService.fullSync();

      if (result.success) {
        setSyncMessage(`✓ ${result.message}`);
      } else {
        setSyncMessage(`✗ ${result.message}`);
      }
    } catch (error) {
      setSyncMessage('✗ Sync failed');
    }

    setSyncing(false);

    // Clear message after 5 seconds
    setTimeout(() => {
      setSyncMessage('');
    }, 5000);
  };

  return (
    <header className="app-header">
      <div className="header-title-bar">
        <h1>Office Attendance Tracker</h1>
        <button
          className="expand-btn"
          onClick={() => setIsExpanded(!isExpanded)}
          title={isExpanded ? "Collapse" : "Expand"}
        >
          {isExpanded ? '▲' : '▼'}
        </button>
      </div>

      {isExpanded && (
        <div className="header-content">
          <div className="header-left">
            <span className="user-name">{userInfo.name}</span>
            <span className="user-email">{userInfo.email}</span>
          </div>

          <div className="header-right">
            {syncMessage && (
              <span className="sync-message">{syncMessage}</span>
            )}

            <button
              className="sync-btn"
              onClick={handleSync}
              disabled={syncing}
              title="Sync with server"
            >
              <span className={`sync-icon ${syncing ? 'spinning' : ''}`}>🔄</span>
              Sync
            </button>

            <button
              className="settings-btn"
              onClick={() => setShowSettings(!showSettings)}
              title="Settings"
            >
              ⚙️
            </button>
          </div>
        </div>
      )}

      {showSettings && (
        <Settings
          onClose={() => setShowSettings(false)}
          onSave={() => {
            loadUserInfo();
            if (onSettingsUpdate) onSettingsUpdate();
          }}
        />
      )}
    </header>
  );
}

export default Header;
